import Cookies from "js-cookie";

const TokenKey = "userToken";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token, rememberMe) {
  if (rememberMe) {
    Cookies.set("loginData", rememberMe);
    return Cookies.set(TokenKey, token);
  } else {
    return Cookies.set(TokenKey, token);
  }
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function logOut() {
  removeToken();
}
